import React from "react"
import { Link } from "gatsby"
import Image from "components/image"

const Stack = () => {
  return (
    <div className="mb-16 md:mb-32">
      <div className="relative lg:py-0 py-10  border-t border-grey-300 border-b">
        <div className="flex lg:flex-row flex-col-reverse justify-between items-center w-10/12 mx-auto relative">
          <div className="lg:w-1/2 mt-5 lg:mt-0">
            <h4
              className="font-semibold text-grey-100"
              style={{ fontSize: "32px" }}
            >
              The back office your bank needs
            </h4>
            <h5 className="text-lg text-blue-dark font-semibold mt-6">
              Standout with our banking system
            </h5>
            <p
              className="text-grey-200 text-base mt-2 w-10/12"
              style={{ lineHeight: "28px" }}
            >
              With a wide range of features that sets your enterprise up for
              improved efficiency and scalability, WoodCore is just what you
              need for your banking operations to go digital.
            </p>
            <div className="mt-4">
              <Link to="/features">
                <div className="flex items-center">
                  <p
                    className="text-green font-medium mr-2 hover:text-green-dark duration-500"
                    style={{ fontSize: "16.7px" }}
                  >
                    Check out more features
                  </p>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="slide"
                  >
                    <path
                      d="M0 13.3907L5.60816 7.77028L0 2.14987L1.72653 0.42334L9.07347 7.77028L1.72653 15.1172L0 13.3907Z"
                      fill="#52BD95"
                    />
                    <path
                      d="M7.84888 13.6968L13.457 8.07643L7.84888 2.45602L9.57541 0.729492L16.9223 8.07643L9.57541 15.4234L7.84888 13.6968Z"
                      fill="#52BD95"
                    />
                  </svg>
                </div>
              </Link>
            </div>
          </div>
          <div className="w-full lg:mt-20 xl:mt-10 lg:w-1/2 relative">
            <div className="mx-auto">
              <Image source="phone" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Stack
